// TODO
//  get from env
export const BASE_URL = 'https://us-central1-cfto-gestionale.cloudfunctions.net';

